import PropTypes from "prop-types";

// @mui material components
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { getImage } from "assets/Images";

export default function HomeFooter({ bgDarkGray = false }) {
	return (
		<MDBox
			component="footer"
			position="absolute"
			bottom={0}
			left={0}
			width="100%"
			py="15px"
			mt={bgDarkGray ? "50px" : 0}
			zIndex={4}
			sx={{
				backgroundColor: bgDarkGray ? "#444041" : "#49accd",
				borderTop: "1px solid #AAAAAA"
			}}
		>
			<MDBox height="30px">
				<MDBox
					component="img"
					src={getImage("logobicolor")}
					alt="DigiHapi bicolor logo"
					title="DigiHapi bicolor logo"
					display="block"
					position="relative"
					top="-85px"
					width="150px"
					mx="auto"
				/>
			</MDBox>
			<Divider light />
			<MDBox textAlign="center" px="15px">
				<MDTypography variant="button" color="white" component="div">
					&copy; {`Copyright ${new Date().getFullYear()} - `}
					<strong>DigiHapi</strong>
				</MDTypography>
				<Link
					href="https://www.digihapi.com/charte-confidentialite"
					target="_blank"
					rel="noreferrer"
					sx={{ color: "#49accd", "&:hover": { color: "#ffffff" } }}
				>
					<MDTypography variant="button" color="inherit">
						Charte de confidentilité
					</MDTypography>
				</Link>
			</MDBox>
		</MDBox>
	);
}

HomeFooter.propTypes = {
	bgDarkGray: PropTypes.bool
};
